module.exports = __webpack_public_path__ + "d1ae632a8513f0c636fc91022297fb8d.gltf";